const initialSpecificationState = [];

const restaurantTypewriterReducer = (state = initialSpecificationState, action) => {
    switch (action.type) {
        case 'SAVE_Writers':
            return [...state, action.payload];
        default:
            return state;
    }
}
export default restaurantTypewriterReducer;